import { FC } from "react";

const EmailIcon: FC = () => {
    return (
        <>
            <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                d="M36.6666 9.99935C36.6666 8.16602 35.1666 6.66602 33.3333 6.66602H6.66659C4.83325 6.66602 3.33325 8.16602 3.33325 9.99935V29.9993C3.33325 31.8327 4.83325 33.3327 6.66659 33.3327H33.3333C35.1666 33.3327 36.6666 31.8327 36.6666 29.9993V9.99935ZM33.3333 9.99935L19.9999 18.3327L6.66659 9.99935H33.3333ZM33.3333 29.9993H6.66659V13.3327L19.9999 21.666L33.3333 13.3327V29.9993Z"
                fill="#167E76"
                />
            </svg>
        </>
    )
}

export default EmailIcon;